import React, { useState, useRef, useEffect  } from 'react';
import Nav from './Nav';
import { Link , useLocation } from 'react-router-dom';
import axios from 'axios';
import WOW from "wowjs";

function HeaderFour() {
    const [headers, setHeaders] = useState([]);
    const [portfolioSection, setPortfolioSection] = useState({});
    const location = useLocation();
    const currentPath = location.pathname;

    const isActive = (path) => currentPath === path;

    useEffect(() => {
        axios.get("https://solanthegroup.com/admin/api/portfolio_section")
            .then((response) => {
                setPortfolioSection(response.data[0]); // Setting Portfolio Section Data
            })
            .catch((error) => console.error("Error fetching section data:", error));

        function header() {
            axios
                .get("https://solanthegroup.com/admin/api/headers")
                .then((response) => {
                    setHeaders(response.data); // Set the fetched data
                })
                .catch((error) => { });
        }
        header();
    }, []);

    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 150) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);



    // header side collups area start here


    const [isOpen, setIsOpen] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('english');
    const pickerRef = useRef(null);

    const languages = [
        { lang: 'de', value: 'deutsch', label: 'Deutsch' },
        { lang: 'en', value: 'english', label: 'English' },
        { lang: 'fr', value: 'francais', label: 'Français' },
        { lang: 'it', value: 'italiano', label: 'Italiano' }
    ];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (pickerRef.current && !pickerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        const handleKeyUp = (event) => {
            if (event.key === 'Escape') {
                setIsOpen(false);
            }
        };

        window.addEventListener('click', handleClickOutside);
        window.addEventListener('keyup', handleKeyUp);

        return () => {
            window.removeEventListener('click', handleClickOutside);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, []);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleLanguageChange = (language) => {
        setSelectedLanguage(language.value);
        setIsOpen(false);
        // Handle redirection or other actions based on language selection
    };

    // side menu active
    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const [isOverlayVisible, setIsOverlayVisible] = useState(false);

    const handleMenuToggle = () => {
        setIsMenuVisible(!isMenuVisible);
        setIsOverlayVisible(!isOverlayVisible);
    };

    const handleCloseMenu = () => {
        setIsMenuVisible(false);
        setIsOverlayVisible(false);
    };

    const handleOverlayClick = () => {
        setIsMenuVisible(false);
        setIsOverlayVisible(false);
    };

    // mobile menu
    const [openMenu, setOpenMenu] = useState(null);

    const toggleMenu = (menuhome) => {
        setOpenMenu(openMenu === menuhome ? null : menuhome);
    };

    return (
        <div>
            {headers.length > 0 && headers.map((header) => (
                <header key={header.id} className={`tmp-header-area-start header-two header-four header-five header--sticky ${isSticky ? 'sticky' : ''}`}>

                    <div className="header-top-one">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="header-top-inner">
                                        <div className="left-information-area">
                                            {/*
                                                <p className="left-top">
                                                    <Link to={`tel:${header.phone}`}>
                                                        <i className="fa-regular fa-phone" /> {header.phone}
                                                    </Link>
                                                </p>
                                            */}
                                            {header.address &&
                                                <div className="location-area">
                                                    <i className="fa-light fa-location-dot" />
                                                    <Link to={'#'}>{header.address}</Link>
                                                </div>
                                            }
                                            <div className="working-time">
                                                <i className="fa-light fa-clock" />
                                                <p>{header.working_time}</p>
                                            </div>
                                        </div>
                                        <div className="right-header-top">
                                            <div className="social-area-transparent">
                                                <span>Follow on</span>
                                                <Link to={`${header.facebook}`}>
                                                    <i className="fa-brands fa-facebook-f" />
                                                </Link>
                                                <Link to={`${header.instagram}`}>
                                                    <i className="fa-brands fa-instagram" />
                                                </Link>
                                                <Link to={`${header.twitter}`}>
                                                    <i className="fa-brands fa-linkedin-in" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="header-mida-area style-two ">
                                    <div className="logo-area-start">
                                        <Link to="/">
                                            <img src={`https://solanthegroup.com/admin/${header.logo}`} alt="logo" style={{ width: "300px" }} />
                                        </Link>
                                    </div>
                                    <div className="header-nav main-nav-one">
                                        <nav>
                                            <ul className="parent-nav">
                                                <li>
                                                    <Link className={`nav-link ${isActive("/") ? "active-link" : ""}`} to="/">
                                                        <span className="rolling-text">HOME</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className={`nav-link ${isActive("/about") ? "active-link" : ""}`} to="/about">
                                                        <span className="rolling-text">
                                                            <div className="block">
                                                                <span className="letter">A</span>
                                                                <span className="letter">B</span>
                                                                <span className="letter">O</span>
                                                                <span className="letter">U</span>
                                                                <span className="letter">T</span>
                                                            </div>
                                                            <div className="block">
                                                                <span className="letter">A</span>
                                                                <span className="letter">B</span>
                                                                <span className="letter">O</span>
                                                                <span className="letter">U</span>
                                                                <span className="letter">T</span>
                                                            </div>
                                                        </span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className={`nav-link ${isActive("/Service") ? "active-link" : ""}`} to="/Service">
                                                        <span className="rolling-text">SERVICE</span>
                                                    </Link>
                                                </li>
                                                {portfolioSection.status === "on" && (
                                                    <li>
                                                        <Link className={`nav-link ${isActive("/Project") ? "active-link" : ""}`} to="/Project">
                                                            <span className="rolling-text">PORTFOLIO</span>
                                                        </Link>
                                                    </li>
                                                )}
                                                <li>
                                                    <Link className={`nav-link ${isActive("/Blog") ? "active-link" : ""}`} to="/Blog">
                                                        <span className="rolling-text">BLOG</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className={`nav-link ${isActive("/Contact") ? "active-link" : ""}`} to="/Contact">
                                                        <span className="rolling-text">CONTACT</span>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <div className="actions-area">
                                        <Link to={'/Service'} className="tmp-btn btn-primary bg-custom">
                                            Get Started Now
                                        </Link>
                                        {/* <div class="menu-button" id="search">
                                        <i class="fa-light fa-grid-2"></i>
                                        </div> */}
                                        <div className="tmp-side-collups-area" id="side-collups" onClick={handleMenuToggle}>
                                            <svg
                                                width={20}
                                                height={16}
                                                viewBox="0 0 20 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <rect y={14} width={20} height={2} fill="#fff" />
                                                <rect y={7} width={20} height={2} fill="#fff" />
                                                <rect width={20} height={2} fill="#fff" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            ))}
            <div id="side-hide" className={isMenuVisible ? 'show' : ''}>
                <div className="top-area">
                    <Link to="/" className="logo-area">
                        <img src="./assets/images/logo/white-logo.png" alt="logo" style={{ width: "300px" }} />
                    </Link>
                    <div className="close-icon-area">
                        <div id="close-slide__main" onClick={handleOverlayClick}>
                            <i className="fa-solid fa-x" />
                        </div>
                    </div>
                </div>
                <div className="body">
                    <h5 className="title">Transforming your ideas into digital reality</h5>
                    <p className="disc">
                        Sed ut perspiciatis unde omnis natus error voluptatem santium doloremque
                        laudantium, totam rem aperiam, eaque.
                    </p>
                    <div className="short-contact-area-side-collups">
                        {/* single contact information */}
                        <div className="single-contact-information-side">
                            <i className="fa-solid fa-phone" />
                            <div className="information">
                                <span>Call Now</span>
                                <a href="#" className="number">
                                    +92 (8800) - 98670
                                </a>
                            </div>
                        </div>
                        {/* single contact information end */}
                        {/* single contact information */}
                        <div className="single-contact-information-side">
                            <i className="fa-light fa-envelope" />
                            <div className="information">
                                <span>Mail Us</span>
                                <a href="#" className="number">
                                    example@info.com
                                </a>
                            </div>
                        </div>
                        <div className="single-contact-information-side">
                            <i className="fa-sharp fa-light fa-location-dot" />
                            <div className="information">
                                <span>Our Address</span>
                                <a href="#" className="number">
                                    66 Broklyant, New York 3269
                                </a>
                            </div>
                        </div>
                    </div>
                    <ul className="social-icons solid-social-icons rounded-social-icons">
                        <li>
                            <a href="#">
                                <i className="fa-brands fa-facebook-f" />
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i className="fa-brands fa-linkedin-in" />
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i className="fa-brands fa-twitter" />
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i className="fa-brands fa-instagram" />
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="mobile-menu-main">
                    <nav className="nav-main mainmenu-nav mt--30">
                        <ul className="mainmenu metismenu" id="mobile-menu-active">
                            <li>
                                <Link to="/" className="main">
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link to="/about" className="main">
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link to="/Service" className="main">
                                    Service
                                </Link>
                            </li>
                            {portfolioSection.status === "on" && (
                                <li>
                                    <Link to="/Project" className="main">
                                        Portfolio
                                    </Link>
                                </li>
                            )}
                            <li>
                                <Link to="/Blog" className="main">
                                    Blog
                                </Link>
                            </li>
                            <li>
                                <Link to="/Contact" className="main">
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <div id="overlay_every-where" className={isOverlayVisible ? 'bgshow' : ''} onClick={handleOverlayClick}></div>
            <style>
                {`
                    .bg-custom
                    {
                        background:#b9862d !important;
                    }

                    .nav-link {
                        position: relative !important;
                        text-decoration: none !important;
                    }

                    .nav-link.active-link::after {
                        content: "" !important;
                        position: absolute;
                        bottom: -2px !important;
                        left: 4px !important;
                        width: 91% !important;
                        height: 2px !important;
                        background-color: #b9862d !important;
                    }

                    @media only screen and (max-width:767px) {
                        .tmp-banner-area{
                            height: 400px !important;
                        }
                    }
                `}
            </style>
        </div>
    )
}

export default HeaderFour